import Greeting from './Greeting'

function App () {
  return (
    <div>
      <Greeting />
    </div>
  )
}

export default App
